<div class="flex-left-column light-control-host sandbox-events-host">
  <div class="modal-header">
    <h3 class="panel-title">Network Sandbox Event Log</h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="close.emit()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <svg lucideX></svg>
    </button>
  </div>

  <p-table
    #dt
    [value]="awsEventLogs"
    [globalFilterFields]="['srcIp', 'srcPort', 'destIp', 'destPort', 'proto', 'action', 'sni']"
    dataKey="flowId"
    [tableStyle]="{ 'min-width': '40rem' }"
    class="p-datatable-sm aws-fwlogs-datatable"
    [rowHover]="true"
    selectionMode="none"
  >
    <ng-template #caption>
      <div class="caption-container">
        <p-iconfield class="filter-container">
          <input
            pInputText
            #filterInput
            type="text"
            class="input-small"
            (keydown)="onKeyDown($event)"
            placeholder="Filter events..."
          />
          @if (!isFilterApplied && !loading) {
            <p-inputicon class="fade-icon"><svg lucideFunnel></svg></p-inputicon>
          }
          @if (isFilterApplied && !loading) {
            <p-inputicon (click)="clearFilter()" class="filter-clear-icon"><svg lucideX></svg></p-inputicon>
          }
          @if (loading) {
            <p-inputicon><svg lucideLoaderCircle class="lucide-spin"></svg></p-inputicon>
          }
        </p-iconfield>

        <select class="arpio-select" [(ngModel)]="timeSelected" (change)="fetchLogs()">
          @for (option of timeOptions; track option) {
            <option [ngValue]="option">{{ option.label }}</option>
          }
        </select>
      </div>
    </ng-template>

    <ng-template #header>
      <tr>
        <th pSortableColumn="timestamp" class="strong-text whitespace-nowrap">
          Timestamp <p-sort-icon field="timestamp"></p-sort-icon>
        </th>
        <th pSortableColumn="srcIp" class="strong-text whitespace-nowrap">
          Source IP <p-sort-icon field="srcIp"></p-sort-icon>
        </th>
        <th pSortableColumn="srcPort" class="strong-text whitespace-nowrap">
          Source Port <p-sort-icon field="srcPort"></p-sort-icon>
        </th>
        <th pSortableColumn="destIp" class="strong-text whitespace-nowrap">
          Destination IP <p-sort-icon field="destIp"></p-sort-icon>
        </th>
        <th pSortableColumn="destPort" class="strong-text whitespace-nowrap">
          Destination Port <p-sort-icon field="destPort"></p-sort-icon>
        </th>
        <th pSortableColumn="proto" class="strong-text whitespace-nowrap">
          Protocol <p-sort-icon field="proto"></p-sort-icon>
        </th>
        <th pSortableColumn="action" class="strong-text whitespace-nowrap">
          Action <p-sort-icon field="action"></p-sort-icon>
        </th>
        <th pSortableColumn="sni" class="strong-text whitespace-nowrap">SNI <p-sort-icon field="sni"></p-sort-icon></th>
      </tr>
    </ng-template>

    <ng-template #body let-log>
      <tr>
        <td>{{ log.timestamp.toISOString() }}</td>
        <td>{{ log.srcIp }}</td>
        <td>{{ log.srcPort }}</td>
        <td>{{ log.destIp }}</td>
        <td>{{ log.destPort }}</td>
        <td>{{ log.proto }}</td>
        <td>{{ log.action }}</td>
        <td>{{ log.sni }}</td>
      </tr>
    </ng-template>

    <ng-template #emptymessage>
      <tr>
        <td colspan="8" class="text-center default-padding loading-text">
          @if (loading) {
            <svg lucideLoaderCircle class="lucide-spin"></svg> Loading events...
          }
          @if (!loading) {
            No events found.
          }
        </td>
      </tr>
    </ng-template>

    <!-- Table Summary -->
    <ng-template #summary>
      <div class="flex gap-2 align-items-center justify-content-between">
        @if (loading) {
          <div>Loading ...</div>
        }
        @if (errorMessage && !loading) {
          {{ errorMessage }} <a (click)="fetchLogs()">Click here to refresh</a>
        }
      </div>
    </ng-template>
  </p-table>

  @if (awsConsoleUrl) {
    <div class="modal-footer">
      <a [href]="awsConsoleUrl" target="_blank">View events in CloudWatch</a>
    </div>
  }
</div>
